import styled from "styled-components";

export const HeroBg = styled.div`
  position: absolute;
  display: flex;
  justify-content: end;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 1360px;
  overflow: hidden;
  padding: 0 30px;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);

  @media (max-width: 960px) {
    justify-content: center; 
    padding: 0 0px;
    margin-top:138%
  }
`;

export const HeroRightContainer = styled.div`
  width: 100%;
  display: flex;
  order: 2;
  justify-content: end;
  margin-top:-37%;
  margin-left:-8%;
  gap: 12px;
  @media (max-width: 960px) {
    order: 1;
    justify-content: center;
    align-items: center;
    margin-bottom: 80px;
    margin-top:20%;
    margin-left:0%
  }

  @media (max-width: 640px) {
    margin-bottom: 30px;
    margin-top:110px;
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  max-width:400px;
  max-height: 400px;
  border-radius:50px;

  @media (max-width: 768px) {
    max-width: 400px;
    max-height: 400px;
  }

  @media (max-width: 640px) {
    max-width: 400px;
    max-height: 400px;
  }
`;
